import styled from 'styled-components';
import media from 'styled-media-query';

import { Link } from 'react-router-dom';

import * as Common from '../../Styles';
import * as MUI from '@mui/material';

const Theme = Common.Theme;

export const SupplierContainer = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	min-height: 2rem;
	margin: 0 0 0.7rem 0.7rem;
	font-size: 18px;
	font-family: 'Prompt', sans-serif;
	font-weight: 500;
	cursor: pointer;
`;

export const MenuContainer = styled.div`
	position: sticky;
	position: -webkit-sticky;
	top: 1rem;
	display: flex;
	flex-direction: column;
	height: 95vh;
	width: auto;
	padding: 0.5rem 1rem;
	${media.lessThan('1200px')`
        display: none;
    `}
`;

export const MenuDrawer = styled(MUI.Drawer).attrs((props) => ({
	PaperProps: { style: { width: 'auto', padding: '1.75rem 1rem 0 1rem' } },
}))``;

export const MenuItem = styled(Link).attrs((props) => ({
	to: props.to || '/',
	selected: props.selected || false,
}))`
	display: flex-inline;
	gap: 0.25rem;
	width: auto;
	min-width: max-content;
	margin: 0rem;
	margin-bottom: 0.5rem;
	padding: 1rem 0.5rem;
	color: ${(props) => (props.selected ? Theme.white : Theme.black)};
	background: ${(props) => (props.selected ? Theme.primary : Theme.creamWhite)};
	border-radius: 4px;
	font-family: 'Prompt', sans-serif;
	font-weight: 500;
	font-size: 18px;
	text-decoration: none;
	text-transform: none;
	outline: none;
	align-items: center;
	justify-content: left;
	cursor: pointer;

	& svg {
		vertical-align: text-top;
	}
`;

export const LogoutButton = styled(MenuItem)`
	position: absolute;
	bottom: 1rem;
	display: inline-flex;
	gap: 0.5rem;
	width: auto;
	font-weight: 400;
	color: ${Theme.primary};
	background: transparent;
`;

export const Popover = styled(Common.Popover)``;

export const PopoverBody = styled(Common.PopoverBody)``;

export const PopoverItem = styled(Common.PopoverItem)``;

export const PopoverTitle = styled(Common.PopoverTitle)``;

export const Search = styled(Common.Search)``;

export const Hidden = styled(MUI.Hidden)``;
